import { getFromApi } from '../../common/utils/apiHelper'

export const getConfiguration = (onSuccess: (data: any) => void, onFail: () => void): void => {
    getFromApi('/config.json', onSuccess, onFail);
}